// Deep links from the notification emails point at /?draft=<id>. The id is stashed on load and
// stripped from the address bar; if the session had lapsed, the Visma login round-trips in the same
// tab, so sessionStorage still holds it when the SPA re-initialises afterwards. Read once, then
// cleared by whoever opens the draft.

const KEY = 'eko_target_draft'
// The company the link was for. A draft id is a Visma attachment id and those are per company, so
// without this a link followed while signed in elsewhere finds nothing and looks like a draft
// somebody has already handled.
const COMPANY_KEY = 'eko_target_company'

/**
 * Take the id out of the URL, before anything else happens.
 *
 * Called at boot rather than by the view that uses it, and that is the whole point: the view only
 * exists once a session and a role do. Someone arriving from an email with no session saw the
 * login dialog, went to Visma, came back to a bare `/` — and the id had never been stored,
 * because the only code that stored it had not rendered. So the deep link worked for exactly the
 * people who did not need it.
 */
export function stashTargetDraft(): void {
  const params = new URLSearchParams(window.location.search)
  const draft = params.get('draft')
  if (draft) {
    sessionStorage.setItem(KEY, draft)
    // Older links carry no company. Absent means "no opinion", not "a different one" — every mail
    // sent before this existed must keep working.
    const company = params.get('company')
    if (company) {
      sessionStorage.setItem(COMPANY_KEY, company)
    } else {
      sessionStorage.removeItem(COMPANY_KEY)
    }
    window.history.replaceState({}, '', window.location.pathname)
  }
}

export function consumeTargetDraft(): string | null {
  return sessionStorage.getItem(KEY)
}

export function consumeTargetCompany(): string | null {
  return sessionStorage.getItem(COMPANY_KEY)
}

export function clearTargetDraft(): void {
  sessionStorage.removeItem(KEY)
  sessionStorage.removeItem(COMPANY_KEY)
}
